import { LoadingState } from './types';

export function createLoadingState<T>(): LoadingState<T> {
    return {
        isFetching: false,
        error: null,
        data: null,
    };
}
